<template>
  <div class="gift-list">
    <ShareWedsiteUrlModal ref="shareWedsiteUrlModal" />
    <Drawer ref="drawer">
      <component
        v-if="component"
        :is="component"
        :data="data"
        @gratefulChanged="changeGrateful"
      ></component>
    </Drawer>

    <div class="gift-list-label">Últimos presentes recebidos</div>
    <div class="gift-list-table">
      <b-field grouped group-multiline v-if="hasGifs">
        <div class="gift-list-search-wrapper">
          <img :src="searchIcon" class="icon-search" />
          <input
            v-on:keyup="queringPag()"
            type="text"
            v-model="query"
            class="gift-list-search"
            placeholder="buscar presente ou convidado"
          />
        </div>
      </b-field>
      <span v-if="!products"> </span>
      <div class="label-error" v-if="hasGifs && labelError">
        {{ labelError }}
      </div>
      <span v-if="productsFiltered && productsFiltered.length > 0">
        <section>
          <b-table
            :row-class="(row, index) => row.name !== 'julia' && 'is-info'"
            class="table-paginator-center"
            :data="productsFiltered"
            :paginated="true"
            :per-page="perPage"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :default-sort-direction="defaultSortDirection"
            default-sort="name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            :page-input="hasInput"
            pagination-order="default"
            :page-input-position="inputPosition"
            :debounce-page-input="inputDebounce"
          >
            <b-table-column
              field="name"
              width="60"
              height="80"
              v-slot="props"
              centered
            >
              <span class="gift-table-content is-hovered">
                <img
                  :src="getUrlImage(props.row.items[0])"
                  class="gift-list-product-image"
                  @click="clickDrawerDetail(props.row, 'DrawerGiftDetailVue')"
                />
                <div
                  v-if="props.row.items.length > 1"
                  :class="props.row.items.length > 1 ? 'plus-badge' : ''"
                >
                  +{{ props.row.items.length - 1 }}
                </div>
              </span>
            </b-table-column>

            <b-table-column
              field="name"
              label="Produto"
              width="210"
              sortable
              v-slot="props"
            >
              <span
                class="gift-table-content"
                @click="clickDrawerDetail(props.row, 'DrawerGiftDetailVue')"
              >
                <span :data-text="props.row.name" class="tooltipInfo">
                  <span class="text-line-clamp-two">{{
                    getSubstring(props.row.name, 38)
                  }}</span>
                </span>
              </span>
            </b-table-column>

            <b-table-column
              field="guest"
              label="Comprado por"
              width="210"
              sortable
              v-slot="props"
            >
              <span :data-text="props.row.guest" class="tooltipInfo">
                <span class="text-line-clamp-two">
                  {{ getSubstring(props.row.guest, 38) }}
                </span>
              </span>
            </b-table-column>

            <b-table-column
              field="value"
              label="Valor"
              sortable
              numeric
              v-slot="props"
              centered
              cell-class="is-vcentered value-padding"
            >
              <span class="gift-table-content">
                {{ getGiftValue(props.row.value) }}
              </span>
            </b-table-column>

            <b-table-column
              field=""
              label="Data do recebimento"
              sortable
              numeric
              v-slot="props"
              centered
              cell-class="is-vcentered"
            >
              <span> {{ props.row.transfered_at }} (até 23h59) </span>
            </b-table-column>

            <b-table-column
              field="date_payment"
              label="Status"
              sortable
              v-slot="props"
              centered
              cell-class="is-vcentered"
            >
              <span class="gift-table-content">
                <span style="color: #5d758d; font-size: 14px"
                  ><span style="font-weight: 700">{{
                    props.row.transfer_status
                  }}</span
                  ><br /><span style="font-weight: 400">{{
                    props.row.date_payment
                  }}</span></span
                >
              </span>
            </b-table-column>

            <b-table-column
              field="grateful"
              label="Agradecer"
              sortable
              numeric
              v-slot="props"
              centered
              cell-class="is-vcentered"
            >
              <div
                class="gift-table-content is-hovered"
                @click="clickDrawerGreet(props.row, 'DrawerGreetVue')"
              >
                <span
                  :class="props.row.grateful ? 'tag greeted' : 'tag greet'"
                  style="
                    font-size: 14px !important;
                    font-weight: 700 !important;
                    padding-top: 8px;
                    padding-bottom: 8px;
                    height: 34px;
                  "
                >
                  {{ props.row.grateful ? 'Agradecido' : 'Agradecer' }}
                </span>
              </div>
            </b-table-column>
          </b-table>
        </section>
        <div
          class="column is-one-third"
          style="
            float: right;
            margin-top: -45px;
            display: inline-flex;
            width: auto;
            font-size: 16px;
            margin-left: auto;
            margin-right: 30px;
          "
        >
          <span style="font-weight: 700">Exibir presentes</span>
          <select
            class="gift-list-perpage"
            v-model="perPage"
            @change="queringPag()"
          >
            <option selected="selected">10</option>
            <option>25</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
      </span>
      <span v-if="products && products.length == 0">
        <div class="empty-list-container" style="display: inline-flex">
          <div class="empty-list-section-img">
            <img :src="GiftLogo" />
          </div>
          <div class="empty-list-section">
            <div class="empty-list-section-label">
              Vocês ainda não receberam presentes
            </div>
            <div class="empty-list-section-sublabel">
              Assim que receberem, eles aparecerão aqui!
            </div>
            <div class="empty-list-section-content">
              Comecem editando a lista de presentes, em seguida, a compartilhe
              com os convidados.
            </div>
            <div class="empty-list-section-buttons">
              <button class="button is-primary" @click="changeTab()">
                Editar Lista
              </button>
              <button class="button tertitary" @click="shareSiteModal()">
                Compartilhar Lista
              </button>
            </div>
          </div>
        </div>
      </span>
    </div>
    <div class="gift-list-table-mobile">
      <b-field grouped group-multiline>
        <div class="gift-list-search-wrapper" v-if="hasGifs">
          <img :src="searchIcon" class="icon-search" />
          <input
            v-on:keyup="queringPag()"
            type="text"
            v-model="query"
            class="gift-list-search"
            placeholder="buscar presente ou convidado"
          />
        </div>
      </b-field>
      <div v-if="hasGifs && labelError" class="label-error-mobile">
        {{ labelError }}
      </div>
      <span v-if="products && products.length > 0">
        <div
          v-for="data in productsFiltered.slice(0, plusProducts)"
          :key="data.id"
          class="gift-list-product-card"
          :class="data.id"
          @click="clickDrawerDetail(data, 'DrawerGiftDetailVue')"
        >
          <div class="gift-list-product-row img-group">
            <img
              :src="getUrlImage(data.items[0])"
              class="gift-list-product-image"
              style="margin-right: 0px"
            />
            <div
              v-if="data.items.length > 1"
              :class="data.items.length > 1 ? 'plus-badge-mobile' : ''"
            >
              +{{ data.items.length - 1 }}
            </div>
          </div>
          <div
            class="gift-list-product-row"
            style="margin-bottom: 12px; margin-top: 8px"
          >
            {{ data.name }}
          </div>
          <div class="gift-list-product-row" style="margin-top: 6px">
            <span class="gift-list-bold-title"
              >Comprado por {{ data.guest }}
            </span>
          </div>
          <div :id="'card-preview' + data.id" class="product-card-preview">
            <div class="gift-list-product-row-score">
              {{ getGiftValue(data.value) }}
            </div>
          </div>
          <div class="gift-list-row-details">
            Ver detalhes <img :src="GiftArrowRight" />
          </div>
        </div>
      </span>

      <div
        class="gift-list-row-plus-gifts"
        @click="addMoreGifts()"
        v-if="
          productsFiltered &&
          productsFiltered.length > products.slice(0, plusProducts).length
        "
      >
        Ver mais presentes <img :src="GiftArrowRight" />
      </div>

      <span v-if="products && products.length == 0">
        <div class="empty-list-mobile">
          <div class="empty-list-container">
            <div class="empty-list-section-img">
              <img :src="GiftLogo" />
            </div>
            <div class="empty-list-section">
              <div class="empty-list-section-label">
                Vocês ainda não receberam presentes
              </div>
              <div class="empty-list-section-sublabel">
                Assim que receberem eles aparecerão aqui!
              </div>
              <div class="empty-list-section-content">
                Comecem editando a lista de presentes, em seguida, a compartilhe
                com os convidados.
              </div>
              <div>
                <button class="button is-primary" @click="changeTab()">
                  Editar Lista
                </button>
                <button class="button">Compartilhar Lista</button>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
    <ModalFirstGifts v-if="productsFiltered.length" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GiftLogo from '@/assets/img/gift-logo.png'
import GiftListShopping from '@/assets/img/gift-list-shopping.png'
import GiftArrow from '@/assets/img/gift-arrow.png'
import GiftArrowRight from '@/assets/img/arrow-support.png'
import searchIcon from '@/assets/img/search-icon.svg'
import GiftsApi from '@/lib/api/Gifts'
import sortIcon from '@/assets/img/chevron-up.svg'
import Drawer from '@/components/Drawer/Drawer.vue'
import DrawerGiftDetailVue from '@/components/Gift/DrawerGiftDetail.vue'
import DrawerGreetVue from '@/components/Gift/DrawerGreet.vue'
import ShareWedsiteUrlModal from '@/components/Shared/ShareWedsiteUrlModal.vue'
import ModalFirstGifts from './ModalFirstGifts.vue'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  components: {
    Drawer,
    DrawerGiftDetailVue,
    DrawerGreetVue,
    ShareWedsiteUrlModal,
    ModalFirstGifts,
  },

  data() {
    return {
      GiftLogo,
      GiftListShopping,
      GiftArrow,
      GiftArrowRight,
      searchIcon,
      products: [],
      productsFiltered: [],
      plusProducts: 5,
      open: false,
      data: {},
      total: 10,
      current: 1,
      perPage: 10,
      rangeBefore: 1,
      rangeAfter: 3,
      order: '',
      size: '',
      isSimple: false,
      isRounded: false,
      hasInput: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      inputPosition: '',
      inputDebounce: '',
      query: null,
      paginationOrder: 'is-centered',
      hasGifs: 0,
      sortIcon: 'fa fa-chevron-up',
      sortIconSize: 'is-small',
      defaultSortDirection: 'asc',
      multiColumnSortingEnabled: true,
      sortingPriority: [],

      component: 'DrawerGiftDetailVue',
      labelError: null,
    }
  },

  mounted() {
    this.getProducts()
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
    }),
  },

  methods: {
    changeGrateful(data) {
      const indexProduct = this.productsFiltered.findIndex(
        (product) => product.id === data.id
      )
      if (indexProduct != -1) {
        this.products[indexProduct].grateful = data.grateful
        this.$set(this.products, indexProduct, this.products[indexProduct])
      }
    },

    clickDrawerDetail(data, component) {
      this.component = component
      this.data = data
      this.$refs.drawer.open({
        title: 'Detalhes do presente',
      })
    },
    clickDrawerGreet(data, component) {
      this.component = component
      this.data = data
      this.$refs.drawer.open({
        title: 'Agradecer presente',
      })
    },
    close() {
      this.query = ''
      this.getProducts()
    },
    getGiftValue(value) {
      value = parseFloat(value)
      return value.toLocaleString('PT-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      })
    },
    queringPag() {
      var value = String(this.query).toLowerCase()
      var result = this.products.filter((o) =>
        Object.entries(o).some((entry) =>
          String(entry[1]).toLowerCase().includes(value)
        )
      )
      this.productsFiltered = result
      if (!this.productsFiltered.length) {
        this.labelError =
          'Ops, não conseguimos localizar este presente ou convidado. Por favor, tente novamente.'
      } else {
        this.labelError = null
      }
    },
    getProducts() {
      const giftsApi = new GiftsApi(this.logonToken)
      this.query = this.query || ''
      giftsApi
        .getLastReceivedGifts(this.query)
        .then((response) => {
          if (response && response.data) {
            this.products = response.data
            this.productsFiltered = this.products
            this.labelError = null
            if (!this.hasGifs) {
              this.hasGifs = this.products && this.products.length > 0
            }
          } else {
            this.products = []
            this.hasGifs = false
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.products = []
            this.labelError = error.response.data.error.message
          }
        })
    },
    getUrlImage(gift) {
      if (gift.img_user == '1') {
        return (
          `${API_LEGACY_URL}/dados/sitenoivos/wed${this.wedId}/presentes/` +
          gift.img
        )
      } else {
        return `${API_LEGACY_URL}/img/presentes/` + gift.img
      }
    },
    getSubstring(str, lng) {
      if (str.length > lng) {
        str = str.substring(0, lng) + '...'
      }

      return str
    },
    getStatus(date_payment) {
      if (date_payment == null || date_payment == '') {
        return 'Pendente'
      }
      var label = ''
      date_payment =
        date_payment.substr(3, 2) +
        '/' +
        date_payment.substr(0, 2) +
        '/' +
        date_payment.substr(6, 4)
      date_payment = date_payment.replaceAll('/', '-')

      if (date_payment > Date.now()) {
        return 'Aguardando liberação'
      } else {
        return 'Liberado na Carteira'
      }
    },
    addMoreGifts() {
      this.plusProducts += 5
    },
    shareSiteModal() {
      this.$refs.shareWedsiteUrlModal.open()
    },
    changeTab() {
      this.$router.push('/presentes/editar-lista')
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltipInfo {
  position: relative;
}

.tooltipInfo:before {
  content: attr(data-text);
  @include position(absolute, 50%, auto, auto, -20px, -50%);
  width: 200px;
  padding: 12px;
  color: $neutral;
  text-align: center;
  font-size: 14px;
  font-family: Lato;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  border: 1.5px solid rgba(180, 197, 214, 0.5);
  border-radius: 8px;
  box-shadow: 0px 6.62802px 8px rgba(221, 231, 241, 0.6);
  opacity: 0;
  visibility: hidden;
  z-index: 0;
  transition: 0.2s all ease-in-out;
  background: #fff;
}

.tooltipInfo:hover:before {
  left: 0;
  opacity: 1;
  visibility: visible;
  z-index: 1;
}

.char-limit {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.char-limit:hover {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: unset;
  -webkit-box-orient: vertical;
}
.label-error {
  padding: 56px 16px 346px;
  font-size: 16px;
  font-weight: 700;
  color: $neutral;
  text-align: center;
}

.plus-badge {
  background-color: $primary;
  border-radius: 100px;
  color: #fff !important;
  width: 22px !important;
  height: 22px !important;
  font-size: 12px;
  font-weight: 700 !important;
  display: grid !important;
  align-items: center;
  position: absolute;
  margin-top: -46px;
  margin-left: 35px;
}

.plus-badge-mobile {
  background-color: $primary;
  border-radius: 100px;
  color: #fff !important;
  width: 22px !important;
  height: 22px !important;
  font-size: 12px;
  font-weight: 700 !important;
  display: inline-flex !important;
  align-items: center;
  position: absolute;
  margin-left: -10px;
  justify-content: center;
}
.label-error-mobile {
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 40px;
  padding-top: 30px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: $neutral;
}

.gift-list-table {
  padding-bottom: 24px;
}
.gift-list-row-plus-gifts {
  color: #3dafb0;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  padding-bottom: 20px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.text-line-clamp-two {
  text-align: left;
  overflow: hidden;
  -webkit-line-clamp: 2;
}

.gift-list-table tr {
  margin-top: 20px !important;
  padding-top: 20px !important;
}

.gift-list-table td {
  margin-top: 20px !important;
  padding-top: 20px !important;
}
.b-table {
  .table {
    td {
      vertical-align: middle !important;
    }
  }
}

.table td,
.table th {
  vertical-align: middle !important;
}

.is-hovered:hover {
  font-weight: 800 !important;
  cursor: pointer;
}
@media (max-width: 1400px) {
  .gift-table-content {
    font-size: 14px !important;
  }

  th {
    font-size: 15px;
    color: red;
  }
}
.greet {
  background-color: rgba(237, 191, 207, 0.3) !important;
  color: $primary !important;
}

.greeted {
  background-color: rgba(176, 228, 230, 0.3) !important;
  color: #3dafb0 !important;
}
.gift-list-search-wrapper {
  width: 648px;
  height: 56px;
  background-color: #fff;
  border-radius: 16px;
  margin-top: 32px;
  margin-left: 24px;
  display: inline-flex;
  align-items: center;
  float: left;
  margin-bottom: 35px;
}

.icon-search {
  width: 24px;
  height: 24px;
  margin-left: 20px;
  opacity: 0.5;
}
.gift-list-search {
  background-color: #fff !important;
  border-radius: 16px;
  width: 520px;
  height: 56px;
  border-color: transparent;
  float: left;
  font-size: 16px;
}

.gift-list-search:focus,
input:focus {
  outline: none;
}
.gift-list-perpage {
  height: 20px;
  width: 58px;
  border: none;
  padding-left: 8px;
  background: none;
  font-size: 16px;
  color: $neutral;
}

.gift-list-perpage:focus,
select:focus {
  outline: none;
}

.gift-list-label {
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  color: $neutraldarkest;
  margin-top: 24px;
  margin-left: 8px;
  justify-content: space-between;
  display: flex;
  margin-bottom: 19px;
}

.gift-list-table {
  background: $neutrallightest;
  border-radius: 16px;
  width: auto;
  height: auto;
  @media (max-width: 1024px) {
    display: none;
  }
}

.gift-list-table {
  width: 100%;
  margin-bottom: 25px;
}

.gift-list-header {
  justify-content: space-between;
  display: flex;
  margin-right: 20px;
  margin-left: 20px;
  background: #fff;
  height: 50px;
  border-radius: 8px;
  align-items: center;
  padding: 15px;
  margin-top: 24px;
  color: $neutral;
}

.gift-list-product {
  justify-content: space-between;
  display: flex;
  margin-right: 20px;
  margin-left: 20px;
  background: #fff;
  height: 72px;
  border-radius: 8px;
  align-items: center;
  padding: 15px;
  margin-top: 24px;
  color: $neutral;
}

.gift-list-product-image {
  width: 40px;
  height: 40px;
  max-width: 40px;
  margin-right: -30px;
  border-radius: 8px;
  object-fit: cover;
}

.gift-list-go-shopping {
  vertical-align: bottom;
  padding-right: 10px;
}

.gift-list-table-all {
  color: #3dafb0;
  font-weight: 700;
  font-size: 16px;
  margin-top: 45px;
}

.gift-arrow {
  vertical-align: middle;
  margin-left: 50px;
  height: 16px;
}

.gift-list-table-mobile {
  background-color: $neutrallightest;
  border-radius: 16px;
  color: $neutral;
  margin-bottom: 30px;
  padding-bottom: 1px;

  @media (min-width: 1024px) {
    display: none;
  }
  .gift-list-product-row {
    text-align: center !important;
    justify-content: center !important;
  }

  .mobile-label-name {
    font-size: 14px;
    font-weight: 400;
    color: $neutral;
  }

  .mobile-label-value {
    font-size: 18px;
    font-weight: 800;
    color: $neutral;
  }
  .gift-list-search-wrapper {
    margin-left: 16px;
    width: 90% !important;
    .gift-list-search {
      width: 90% !important;
    }
  }
}

.gift-list-product-card {
  padding-top: 16px !important;
  text-align: center !important;
  width: auto;
  background-color: #fff;
  border-radius: 16px;
  margin-bottom: 40px;
  display: block;
  margin-right: 16px;
  margin-left: 16px;
  height: 194px;

  .gift-list-product-row {
    padding-right: 49px;
    padding-left: 49px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .gift-list-row-details {
    color: #3dafb0;
    font-size: 14px;
    font-weight: 700;
    margin-top: 11px;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .gift-list-product-row-score {
    color: $neutral;
    font-size: 18px !important;
    font-weight: 800 !important;
  }

  .gift-list-product-row-expand {
    font-size: 16px;
    font-weight: 400;
    color: $neutral;
    text-align: right;
    padding-right: 20px;
    padding-top: 24px;

    svg {
      margin-left: 10px;
    }
  }

  .gift-list-product-row-hide {
    font-size: 16px;
    font-weight: 400;
    color: $neutral;
    text-align: right;
    padding-right: 20px;
    padding-top: 24px;
    display: none;

    svg {
      margin-left: 10px;
    }
  }

  .product-card-preview {
    justify-content: center;
  }
  .product-card-expanded {
    display: none;
  }

  .btn-go-to-shopping-card {
    width: 70%;
    height: 52px;
    font-size: 14px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .gift-value {
    color: $primary;
  }
}

.empty-list-container {
  display: flex;
  align-items: center;
  padding-top: 25px;
  background-color: transparent;
  padding: 40px;
  background: #fff;
  width: -webkit-fill-available;
  margin: 24px;
  margin-bottom: 0px;
  border-radius: 16px;

  @media (max-width: 768px) {
    display: inline-block;
  }

  .empty-list-section-img {
    width: 35%;
    text-align: right;
    padding-right: 20px;

    @media (max-width: 768px) {
      width: 100%;
      display: block;
      text-align: center;
    }
  }
  .empty-list-section {
    width: 65%;
    text-align: left;

    @media (max-width: 768px) {
      width: 100%;
      display: block;
      text-align: center;
    }

    img {
      text-align: right !important;
    }
    .empty-list-section-label {
      color: $primary;
      font-size: 18px;
      font-weight: 700;
    }

    .empty-list-section-sublabel {
      color: $neutral;
      font-size: 16px;
      font-weight: 700;
    }

    .empty-list-section-content {
      padding-top: 15px;
      font-size: 16px;
    }

    .empty-list-section-buttons {
      display: inline-flex;
    }

    button {
      margin-right: 10px;
      margin-top: 20px;
    }

    .secondary:hover {
      color: #000;
    }
  }
}

.empty-list-mobile {
  border-radius: 16px;
  display: flex;
  margin-bottom: 16px;
}
</style>
